/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_StripeInputs */

const en_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe`)
};

const ar_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe`)
};

const bn_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe`)
};

const de_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe`)
};

const es_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe`)
};

const fr_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe`)
};

const pt_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe`)
};

const zh_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`条纹`)
};

const tr_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe`)
};

const ru_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe`)
};

const pl_svchip_stripe = /** @type {(inputs: Svchip_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe`)
};

/**
* | output |
* | --- |
* | "Stripe" |
*
* @param {Svchip_StripeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_stripe = /** @type {((inputs?: Svchip_StripeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_StripeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_stripe(inputs)
	if (locale === "bn") return bn_svchip_stripe(inputs)
	if (locale === "de") return de_svchip_stripe(inputs)
	if (locale === "es") return es_svchip_stripe(inputs)
	if (locale === "fr") return fr_svchip_stripe(inputs)
	if (locale === "pt") return pt_svchip_stripe(inputs)
	if (locale === "zh") return zh_svchip_stripe(inputs)
	if (locale === "tr") return tr_svchip_stripe(inputs)
	if (locale === "ru") return ru_svchip_stripe(inputs)
	if (locale === "pl") return pl_svchip_stripe(inputs)
	return en_svchip_stripe(inputs)
});